import axios from "axios";
import Qs from "qs";
import { isPC } from '@/assets/js/common'
import Vue from "vue";
import Element from "element-ui";

let loading;
function startLoading() {
  loading = Vue.prototype.$loading({
    lock: true,
    text: "玩命加载中...",
    target: document.querySelector(".loading-area") //设置加载动画区域
  });
}
function endLoading() {
  loading.close();
}
//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

let instance = axios.create({
  // headers: {'Content-Type': 'multipart/form-data'},
  timeout: 60000,
  withCredentials: true // 允许携带cookie
});
instance.defaults.transformRequest = [
  function(data) {
    return Qs.stringify({
      ...data
    });
  }
];
instance.defaults.headers.put["Content-Type"] = "multipart/form-data";
instance.interceptors.request.use(
  config => {
    showFullScreenLoading();
    return config;
  },
  error => {
    tryHideFullScreenLoading();
    Message.error({ message: "请求超时!" });
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  response => {
    tryHideFullScreenLoading();
    let { data } = response;
    if (data.code === 401 && isPC()) {
      console.log(1);
      
      window.location.href = '/#/login'
      return {code: -1}
    }
    if (data.code !== 0 && data.code !== 2000) {
      Element.Message({
        type: 'error',
        message: data.msg
      })
      return {code: -1}
    }
    return data;
  },
  error => {
    alert(error.message)
    tryHideFullScreenLoading();
  }
);

export default {
  // 以query形式传参
  get(url, params, headers) {
    let options = {};

    if (params) {
      options.params = params;
    }
    if (headers) {
      options.headers = headers;
    }
    return instance.get(url, options);
  },
  // 以params形式传参
  getParams(url, params) {
    return instance.get(url + "/" + params);
  },
  post(url, params) {
    return instance.post(url, params);
  },
  put(url, params, headers) {
    let options = {};

    if (headers) {
      options.headers = headers;
    }
    return instance.put(url, params, options);
  },
  delete(url, params, headers) {
    let options = {};

    if (params) {
      options.params = params;
    }
    if (headers) {
      options.headers = headers;
    }
    return instance.delete(url, options);
  }
};